import BidModel from '../models/BidModel';

export default class BidsCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = BidModel;
  }

  url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
      appConstants.ApiPaths.API_VERSION_PATH +
      appConstants.EndPoints.BIDS_CREATE_PATH
    );
  }

  parse(data) {
    return data.bids ? data.bids : data;
  }

  dispatchCallback(payload) {
    let actionType = payload.actionType;
    let ActionTypes = appConstants.ActionTypes;

    switch (actionType) {
      case ActionTypes.BID_ON_DROPPED_SHIFT: {
        Utils.setMakeshiftTokenHeader();
        const dropURL =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.BIDS_CREATE_PATH.replace(
            '%d',
            payload.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')],
          );
        $.ajax({
          context: this,
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          url: dropURL,
          success: function(collection, response) {
            BidsStore.onExchangeDropPickUpHandler(collection, response, payload.postData);
          },
          error: BidsStore.onExchangeBidsError,
        });
        break;
      }
      case ActionTypes.BID_ON_EXCHANGE: {
        Utils.setMakeshiftTokenHeader();
        const bids = payload.postData[Utils.getEndpointParam('SHIFT_IDS_PARAM')];
        let bidURL =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.BIDS_CREATE_PATH;
        bidURL = bidURL.replace(
          '%d',
          payload.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')],
        );
        const bidArray = [];
        for (let i = 0; i < bids.length; i++) {
          const newBid = new BidModel({
            shift_id: payload.postData[Utils.getEndpointParam('SHIFT_IDS_PARAM')][i],
            exchange_id: payload.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')],
            user_id: Utils.getCoreUser().id,
          });
          bidArray.push(newBid);
        }

        $.ajax({
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          url: bidURL,
          data: JSON.stringify(payload.postData),
          success: function(collection, response) {
            BidsStore.onExchangeBidsHandler(collection, response, payload.postData);
          },
          error: BidsStore.onExchangeBidsError,
        });

        break;
      }
      case ActionTypes.DELETE_BIDS: {
        Utils.setMakeshiftTokenHeader();
        const bidCancelURL =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.BIDS_DELETE_PATH.replace(
            '%d',
            payload.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')],
          );

        const exchangeModel = ExchangesStore.get(
          payload.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')],
        );
        const bids = BidsStore.getBidsByExchangeID(
          payload.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')],
        );
        let bid = null;
        let bidID = null;

        if (bids.length > 0) {
          for (let i = 0; i < bids.length; i++) {
            if (bids[i].user_id === Utils.getCoreUser().id) {
              bid = bids[i];
              bidID = bids[i].id;
              bids.splice(i, 1);
              BidsStore.remove(bid);
              i--;
            }
          }
        }
        /*
        if (bidID != null) {
          const bid = BidsStore.get(bidID);
          BidsStore.remove(bid);
        }
        */
        $.ajax({
          method: 'DELETE',
          dataType: 'json',
          url: bidCancelURL,
          contentType: 'application/json',
          success: function(collection, response) {
            BidsStore.onDestroyBidSuccess(collection, response, payload.postData);
          },
          error: BidsStore.onDestroyBidError,
        });

        break;
      }
    }
  }
}
